import { useQuery } from "@tanstack/react-query";
import { DocumentoElectronico, DocumentosElectronicosQuery } from "@/shared/types/documento-electronico";
import { QueryConfig, QueryResponse } from "@/shared/types/base";
import { api } from "@/api";
import { removeNullOrEmptyKeys } from "@/shared/utils";

export const getDocumentosElectronicos = async (query: DocumentosElectronicosQuery): Promise<QueryResponse<DocumentoElectronico>> => {
    const response = await api.get("/de", { params: removeNullOrEmptyKeys(query) });
    return response.data;
};

export const useGetDocumentosElectronicosQuery = (query: DocumentosElectronicosQuery = {}, queryConfig: QueryConfig<QueryResponse<DocumentoElectronico>> = {}) => {
    return useQuery({
        ...queryConfig,
        queryKey: ["documentos-electronicos", query],
        queryFn: () => getDocumentosElectronicos(query),
    });
};
